export const patientNoteAction = {
  setCurrentPatientNote: (state, action) => {
    state.currentPatientNote = action.payload;
  },
  loadPatientNotes: (state, action) => {
    const payload = action.payload;

    const existPatientNote =
      payload &&
      typeof payload !== "string" &&
      state.patientNoteList?.length > 0 &&
      state.patientNoteList?.some((patientNote) => patientNote === payload);

    if (typeof payload === "string" && existPatientNote === false) {
      state.patientNoteList?.push(payload);
    } else {
      state.patientNoteList = action.payload ?? [];
    }

    state.currentPatientNote = {};
  },
  onPatientNotesChange: (state, action) => {
    const { index, value } = action.payload;

    state.currentPatientNote = {
      index: index,
      note: value,
    };
  },
  onPatientNotesFocus: (state, action) => {
    state.patientNotesFocused = action.payload;
  },
  cancelPatientNotes: (state, action) => {
    const { expanded, focused } = action.payload;

    state.patientNotesExpanded = expanded;
    state.currentPatientNote = {};
    state.patientNotesFocused = focused;
  },
  editPatientNote: (state, action) => {
    state.isEditPatientNote = action.payload;
  },
};
